import RawCard from '@mui/material/Card'
import CardContent from '@mui/material/CardContent'
import {styled} from 'common'

const Card = ({children, ...p}) => {
    return (
        <StyledCard {...p}>
            <CardContent>{children}</CardContent>
        </StyledCard>
    )
}

export default Card

const StyledCard = styled(RawCard)`
    background-color: #fff;
    border-radius: 10px;
    box-shadow: 0 2px 20px rgba(0, 0, 0, 0.2) !important;
    overflow: hidden;
`
